module.exports = __webpack_public_path__ + "img/logout.097f65d9.svg";